import React from 'react';
import { 
  Popover, 
  Box, 
  MenuItem, 
  ListItemIcon, 
  ListItemText, 
  Divider 
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

const DesktopProfileMenu = ({ 
  open,
  anchorEl,
  onClose,
  onLogout,
  onProfileManage,
  userEmail,
  t
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        mt: 1,
        zIndex: 9999,
        '& .MuiPaper-root': {
          minWidth: 200,
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          zIndex: 9999
        }
      }}
      slotProps={{
        root: {
          style: {
            zIndex: 9999
          }
        }
      }}
    >
      <Box sx={{ py: 1 }}>
        <MenuItem onClick={onClose} sx={{ py: 1.5, px: 2 }}>
          <ListItemIcon>
            <EmailIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText 
            primary={userEmail || t('common.noEmail', '이메일 없음')}
            primaryTypographyProps={{
              fontSize: '14px',
              color: '#666'
            }}
          />
        </MenuItem>
        
        <Divider />
        
        <MenuItem onClick={onProfileManage} sx={{ py: 1.5, px: 2 }}>
          <ListItemIcon>
            <ManageAccountsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText 
            primary={t('header.profileManagement')}
            primaryTypographyProps={{
              fontSize: '14px',
              fontWeight: 500
            }}
          />
        </MenuItem>
        
        <Divider />
        
        <MenuItem onClick={onLogout} sx={{ py: 1.5, px: 2 }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText 
            primary={t('common.logout')}
            primaryTypographyProps={{
              fontSize: '14px',
              fontWeight: 500
            }}
          />
        </MenuItem>
      </Box>
    </Popover>
  );
};

export default DesktopProfileMenu; 